<template>
  <div class=Player>
    <div class="personal">
      <div class="v-subheader mt-0">개인 랭킹</div>
      <transition-group class="v-list" v-if="players" name="list">
        <div class="v-list-item px-1 transition-800ms relative" :class="[player.team]" v-for="player in players" :key=player.rank>
          <span class="v-list-item-avatar" @click="select(player)">
            <img :src="'/static/img/' + player.avatar + '_Portrait.png'" :alt="player.name">
          </span>
          <div class="v-list-item-content">
            <input id=input class=name v-if="player.edit" :placeholder="player.name" @blur="e => updateName(e, player)" @keyup.enter="e => updateName(e, player)">
            <div class=name v-else @click="e => editName(e, player)">
              {{ player.name }}
              <a :href="player.href" target="_blank">
                <span v-if="player.href" class="twitch cursor-pointer"></span>
              </a>
            </div>
            <div class=team><span :class="[player.team]">{{ player.team }}</span> team</div>
          </div>
          <div class="v-list-item-score">
            {{ player.score }}
          </div>
          <div class="delete cursor-pointer" v-if="editable" @click="removeUser(player)">X</div>
        </div>
      </transition-group>
      <div v-if="editable" class="mt-1">
        <button @click="reset">리셋</button>
        <button @click="showDetail('add')">추가</button>
      </div>
    </div>
    <div class="team">
      <div class="v-subheader mt-0">팀 점수</div>
      <div class="teamGraphAlt">
        <TeamGraph :team=team style="margin: 0 auto;" />
      </div>
      <div class="d-flex" v-if="team">
        <div class="red">
          <img src="/static/img/Red_Hound.png" alt="레드팀" style="max-width: 20vw;">
          <transition-group class="players v-list" name="list">
            <div class="player v-list-item px-2 transition-800ms" v-for="player in team.red.players" :key="player.rank">
              <span class="v-list-item-avatar">
                <img :src="'/static/img/' + player.avatar + '_Portrait.png'" :alt="player.name">
              </span>
              <div class="v-list-item-content">
                <div class=name>{{ player.name }}</div>
                <div class=rank>{{ player.rank }} 위</div>
              </div>
              <div class="v-list-item-score">
                {{ player.score }}
              </div>
            </div>
          </transition-group>
        </div>
        <div class="teamGraph">
          <TeamGraph :team=team style="flex: 0;" />
        </div>
        <div class="blue">
          <img src="/static/img/Blue_Hound.png" alt="블루팀" style="max-width: 20vw; transform: scale(-1, 1);">
          <transition-group class="players v-list" name="list">
            <div class="player v-list-item px-2 transition-800ms" v-for="player in team.blue.players" :key="player.rank">
              <span class="v-list-item-avatar">
                <img :src="'/static/img/' + player.avatar + '_Portrait.png'" :alt="player.name">
              </span>
              <div class="v-list-item-content">
                <div class=name>{{ player.name }}</div>
                <div class=rank>{{ player.rank }} 위</div>
              </div>
              <div class="v-list-item-score">
                {{ player.score }}
              </div>
            </div>
          </transition-group>
        </div>
      </div>
    </div>
    <transition name=up>
      <div class="detail fixed-fullscreen justify-align-center" v-if="modeDetail" @click.self="hideDetail">
        <div class="wrapper flex-direction-column">
          <div class="title mx-1 text-left">
            <h3>{{ modeDetail === 'add' ? '추가' : '수정' }}</h3>
          </div>
          <div class="content flex-1"  style="border-top: solid 1px #ccc; border-bottom: solid 1px #ccc;">
            <div v-if="selected">
              <div>
                <span class="label">id</span>
                <input v-model="selected.id" />
              </div>
              <div>
                <span class="label">이름</span>
                <input v-model="selected.name" />
              </div>
              <div>
                <span class="label">트위치 주소</span>
                <input v-model="selected.href" />
              </div>
              <div class=team>
                <span class="label">팀</span>
                <span
                  class="red cursor-pointer"
                  :class="{selected: editTeam ? editTeam === 'red' : selected.team === 'red'}"
                  @click="editTeam = 'red'"
                >Red</span>
                <span
                  class="blue cursor-pointer"
                  :class="{selected: editTeam ? editTeam === 'blue' : selected.team === 'blue'}"
                  @click="editTeam = 'blue'"
                >Blue</span>
              </div>
              <div class="d-flex">
                <span class="label">아바타</span>
                <span class="avatar flex-1">
                  <span
                    class="cursor-pointer"
                    :class="{selected: avatar === selected.avatar}"
                    v-for="avatar in avatars"
                    :key=avatar
                    :style="{backgroundImage: 'url(/static/img/' + avatar + '_Portrait.png)'}"
                    @click="selected.avatar = avatar"
                  >
                  </span>
                </span>
              </div>
            </div>
            <div v-else>
              <div>
                <span class="label">이름</span>
                <input v-model="add.name" />
              </div>
              <div>
                <span class="label">트위치 주소</span>
                <input v-model="add.href" />
              </div>
              <div class="d-flex">
                <span class="label">아바타</span>
                <span class="avatar flex-1">
                  <span
                    class="cursor-pointer"
                    :class="{selected: avatar === add.avatar}"
                    v-for="avatar in avatars"
                    :key=avatar
                    :style="{backgroundImage: 'url(/static/img/' + avatar + '_Portrait.png)'}"
                    @click="add.avatar = avatar"
                  >
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div class="action m-1 text-right">
            <span class="cursor-pointer mr-1" @click="hideDetail">닫기</span>
            <span class="cursor-pointer ml-1" @click="update">{{ modeDetail === 'add' ? '추가' : '적용' }}</span>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import TeamGraph from '@/components/TeamGraph'

export default {
  name: 'Player',
  components: { TeamGraph },
  props: ['players', 'team', 'permission'],
  data: () => ({
    modeDetail: null,
    selected: null,
    editTeam: null,
    add: {
      name: null,
      href: null,
      team: null,
      avatar: null
    },
    avatars: [
      'Wilson',
      'Willow',
      'Wolfgang',
      'Wendy',
      'WX-78',
      'Wickerbottom',
      'Woodie',
      'Wes',
      'Waxwell',
      'Wigfrid',
      'Webber',
      'Winona',
      'Warly',
      'Wortox',
      'Wormwood',
      'Wurt',
      'Walter',
      'Wanda'
    ]
  }),
  computed: {
    editable () {
      return ['master', 'manager'].includes(this.permission)
    }
  },
  methods: {
    select (player) {
      if (!this.editable) return
      this.selected = {...player}
      this.showDetail('edit')
    },
    editName (e, player) {
      if (this.editable) {
        console.log('permission authed')
        player.edit = true
        this.$forceUpdate()
        setTimeout(() => {
          document.querySelector('#input').focus()
        }, 100)
      }
    },
    updateName (e, player) {
      if (!this.editable) return
      if (e.target.value && e.target.value.length) {
        this.$socket.client.emit('updateUser', {id: player.id, name: e.target.value})
        e.target.value = ''
      }
      player.edit = false
      this.$forceUpdate()
    },
    showDetail (mode) {
      if (!this.editable) return
      this.modeDetail = mode
      if (mode === 'add') {
        const red = this.team.red.players.length
        const blue = this.team.blue.players.length
        this.add.team = red > blue ? 'blue' : red < blue ? 'red' : Math.random() > 0.5 ? 'red' : 'blue'
      }
    },
    hideDetail () {
      this.modeDetail = null
    },
    update () {
      if (!this.editable) return
      if (this.modeDetail === 'add') {
        this.$socket.client.emit('addUser', {...this.add, score: 0})
        this.add.name = null
        this.add.href = null
        this.add.avatar = null
      }
      if (this.modeDetail === 'edit') {
        this.$socket.client.emit('updateUser', {...this.selected, editTeam: this.editTeam})
        this.selected = null
      }
      this.modeDetail = null
    },
    removeUser (player) {
      if (!this.editable) return
      this.$socket.client.emit('removeUser', {id: player.id})
    },
    reset () {
      if (!this.editable) return
      this.$socket.client.emit('test')
    }
  }
}
</script>

<style scoped>
.Player {
  display: flex;
  flex-direction: row;
  margin: 40px auto 0;
  padding: 0 1em;
  max-width: 1080px;
  gap: 1em;
}
.Player>div {
  border: solid 1px #b0b0ba;
  background: #f3f4f7;
  padding: 1em;
}
.personal {
  width: 30%;
}
.team {
  width: 70%;
}
.team>div>div {
  flex: 1;
  width: 50%;
}
.team .teamGraphAlt {
  display: none;
}
.v-list-item-avatar img {
  transition: transform .5s;
}
.v-list-item:hover img {
  transform: scale(1.1, 1.1);
}
.v-list-item-content>.name {
  font-size: 14px;
  font-weight: 1000;
  white-space: nowrap;
}
.v-list-item-content .twitch {
  display: inline-block;
  margin-left: 5px;
  width: 16px;
  height: 16px;
  background-image: url('/static/img/twitch.png');
  background-size: 16px 16px;
  vertical-align: -3px;
}
.v-list-item-content>.rank,
.v-list-item-content>.team {
  color: #53535f;
  font-size: 13px;
  font-weight: 400;
}
.v-list-item>.delete {
  display: none;
  position: absolute;
  right: -10px;
  top: 50%;
  transform: translate(-50%, -50%);
}
.v-list-item:hover>.delete {
  display: block;
}
.v-list-item-content>input.name {
  width: 50px;
}
.detail.fixed-fullscreen {
  background: #0000;
  border: none;
  z-index: 10;
}
.detail .wrapper {
  width: 90vw;
  max-width: 480px;
  height: 90vh;
  max-height: 640px;
  text-align: left;
  background: white;
  border-radius: 10px;
  box-shadow: 0 0 5px #000a;
}
.detail .content {
  padding: 1em;
}
.detail .content>div>div {
  margin-bottom: 10px;
}
.detail .label {
  display: inline-block;
  margin-right: 10px;
  width: 100px;
  color: #999;
  font-size: small;
  text-align: right;
}
.detail .team .red,
.detail .team .blue {
  padding: 5px 10px;
  border-radius: 5px;
  border: solid 1px transparent;
}
.detail .team .selected {
  border: solid 1px #aaa;
}
.detail .team .red {
  background: #ffdad8;
}
.detail .team .red.selected {
  background: #ffbcba;
}
.detail .team .blue {
  background: #e1ecff;
}
.detail .team .blue.selected {
  background: #c5daff;
}
.detail .avatar>span {
  display: inline-block;
  width: 50px;
  height: 50px;
  background-size: 50px 50px;
  border-radius: 50%;
  filter: grayscale(1);
  transition: all .3s;
}
.detail .avatar>span.selected,
.detail .avatar>span:hover {
  filter: none;
  background-color: #ddd;
  border-radius: 5px;
}
.up-enter-active, .up-leave-active {
  transition: all .5s ease-in-out;
}
.up-enter, .up-leave-to {
  transform: translateY(100%);
}
@media screen and (max-width: 860px) {
.Player {
  flex-direction: column;
}
.Player>.personal, .Player>.team {
  margin: 0 auto;
  width: 90%;
}
}
@media screen and (max-width: 640px) {
.team .teamGraph {
  display: none;
}
.team .teamGraphAlt {
  display: block;
}
}
@media screen and (max-width: 540px) {
.team .v-list-item-avatar {
  display: none;
}
}
</style>



// WEBPACK FOOTER //
// src/components/Player.vue